import { rankWith, isStringControl } from '@jsonforms/core';

export default rankWith(3, isStringControl);
